import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { AuthenticationService } from './services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { UserAuthService } from './services/user-auth.service';
import { NotificationService } from './services/notification.service';
import { OrganisationUser } from './models/auth-user';
import { LoggedInUser } from './services/managerial-operations.service';
import { MatDialog } from '@angular/material/dialog';
import { PluginsService } from '../lib/sofbox/plugins.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  socket: any;
  organisationCode: string;
  isBrowser: boolean;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    public translate: TranslateService,
    public uauthService: UserAuthService,
    public notify: NotificationService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    public plugin: PluginsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  title = 'focusro-web-app';

  ngOnInit() {
    if (this.isBrowser) {
      const classList = this.document.body.classList;
      const lang = localStorage.getItem('lang');

      if (classList.value !== '') {
        this.document.body.classList.replace(classList[0], lang || 'english');
      } else if (!lang) {
        this.document.body.classList.add('english');
      } else {
        this.document.body.classList.add(lang);
      }

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          window.scrollTo(0, 0);
        }
      });

      window.addEventListener('storage', (event) => {
        if (event.key === 'reloadTrigger') {
          this.router.navigateByUrl('/app').then(() => {
            window.location.reload();
          });
        }
      });
    }

    this.authService.getCurretUser().subscribe(
      (userInfo) => {
        if (userInfo.roleId == 2 || userInfo.roleId == 1) {
          if (this.uauthService.checkTokenExpired(this.uauthService.getAuthToken())) {
            this.uauthService.refreshToken().subscribe();
          }
        }
        if (userInfo instanceof LoggedInUser || userInfo instanceof OrganisationUser) {
          this.organisationCode = userInfo.organisationCode;
        }
      },
      (err) => err
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.dialog.closeAll();
      }
    });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.url.split('?')[0];
        if (currentRoute == '/app/gallery/report') {
          this.plugin.activateLink('/app/gallery');
        }
        // Add your additional route handling here
      }
    }, err => console.log(err));
  }
}
